<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn search-picker">
                <div class="search-ctn-right">
                    <div class="search-name">部门</div>
                    <el-cascader
                        ref="orgCascader"
                        class="search-item"
                        v-model="searchData.OrgId"
                        :options="orgSearchData"
                        :props="cascaderProps"
                        size="small"
                        clearable
                        @change="getSIdData"
                        @visible-change="getOrgTree"
                    ></el-cascader>
                    <div class="search-name">上架员</div>
                    <el-select v-model="searchData.SIds" multiple collapse-tags size="small" class="search-item" filterable placeholder="请选择">
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                    <div class="search-name">上架时间</div>
                    <el-date-picker
                        v-model="dateTime"
                        type="daterange"
                        align="right"
                        size="small"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd"
                        @change="handleChange"
                        class="search-name"
                    ></el-date-picker>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="getPickerTableData">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button v-if="isCanTBSet" size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showTableSetDialog()">表格设置</el-button>
                        <el-button size="small" class="search-btn btn-primary" v-if="permission.export" @click="exportData">
                        <i class="fa fa-file-excel-o"></i>
                        {{ permission.export }}</el-button>                                  
                    </div>
                </div>
            </div>
            <div class="table-ctn">
                <ux-grid
                    ref="multipleTable"
                    :data="tableData"
                    border
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummaries"
                    @sort-change="sortChange"
                    :sort-config="{ defaultSort: { field: 'StTotalAmount', order: 'asc' } }"
                >
                <template v-for="(col,index) in columnShowSets">
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            :field="col.ColumnCode"
                            v-if="col.ColumnCode == 'Index'"
                            type="index"
                            show-overflow-tooltip
                        >
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            :field="col.ColumnCode"
                            show-overflow-tooltip
                            v-else-if="col.ColumnCode == 'OrgName' || col.ColumnCode == 'SName'"
                        >
                        </ux-table-column>
                        <ux-table-column
                            v-bind:key="col.ColumnCode + index"
                            :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName"
                            resizable
                            :sortable="col.IsSort"
                            header-align
                            :prop="col.ColumnCode"
                            :field="col.ColumnCode"
                            show-overflow-tooltip
                            v-else
                        >
                        </ux-table-column>
                    </template>
                    <ux-table-column v-if="isExObj('PerfAmount')" resizable :title="item.LevelName" min-width="100px" v-for="(item, index) in perfSetList" :key="index+'PerfAmount_H'">
                        <template slot-scope="scope">
                            <span v-for="(item2, index2) in scope.row.PerfAmountDetails" v-if="item.LevelName == item2.Text" :key="index2+'PerfAmount'">
                                {{ item2.Value }}
                            </span>
                        </template>
                    </ux-table-column>
                    <ux-table-column v-if="isExObj('LabelPerfAmount')" resizable :title="item.LevelName + '(标签)'" min-width="100px" v-for="(item, index) in perfSetList" :key="index+'LabelPerfAmount_h'">
                        <template slot-scope="scope">
                            <span v-for="(item2, index2) in scope.row.LabelPerfAmountDetails" v-if="item.LevelName == item2.Text" :key="index2='LabelPerfAmount'">
                                {{ item2.Value }}
                            </span>
                        </template>
                    </ux-table-column>
                </ux-grid>
            </div>
        </div>
        <!-- <el-dialog :title="pickDialogTitle" :close-on-click-modal="false" :visible.sync="historyVisible" append-to-body width="1000px">
            <div v-if="historyVisible">
                <APPickerHistory :SId="sId" :StartDate="searchData.StartDate" :EndDate="searchData.EndDate" @closeDialog="historyVisible = false"></APPickerHistory>
            </div>
        </el-dialog> -->
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="tableSetsVisible = false" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="tableSetsVisible = false"></tableSets>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import tableSets from '@/components/common/tableSets_v2.vue';
// import APPickerHistory from '@/components/common/APPickerHistory';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        breadcrumb,
        tableSets
        // APPickerHistory
    },
    data() {
        return {
            isCanTBSet:false,
            tableCode: 'StockUpStat',
            tableSetsVisible: false,
            historyVisible: false,
            dateTime: [],
            orgSearchData: [],
            pickDialogTitle: '',
            sId: '',
            searchData: {
                OrgId: '',
                SId: '',
                SIds: [],
                StartDate: '',
                EndDate: ''
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            SIdList: [],
            tableSaleData: [],
            tableSaleDataLength: 0,
            tableData: [],
            tableDataLength: 0,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            columnShowSets: [],
            perfSetList:[],
            permission:{},
            SortProp:'',
            SortType:'',
        };
    },
    created() {
        if (this.tableCode) this.getSetsData();
        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        if (day1 == 1) {
            let date1 = new Date(year1, month1, day1, 0);
            this.dateTime.push(date1);
            this.searchData.EndDate = date1;
        } else {
            let date1 = new Date(year1, month1, day1 - 1, 0);
            this.dateTime.push(date1);
            this.searchData.EndDate = date1;
        }
        //前一天设定的日期时间
        let year2, month2, day2;
        d.setTime(d.getTime());
        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1];
        let date2 = new Date(year2, month2, day2, 0);
        this.dateTime.unshift(date2);

        this.searchData.StartDate = date2;
    },
    mounted() {
        this.permission = this.$util.getPermission('stockUpStat');
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getPickerTableData();
        this.getConfigByCodes();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['ygsfkzdylb'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'ygsfkzdylb': //是否可自定义列表
                                this.isCanTBSet = result;
                                break;
                        }
                    }
                }
            });
        },
        renderHeader(h, { column }) {
            const stTotalCount = [
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '首次将标签存入到标准仓的商品总数'
                )
            ];
            const stTotalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '标准仓总额计算公式：标签定格的成本价 * 商品总数'
            );
            const tempTotalCount = [
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '首次将标签存入到临时仓的商品总数'
                )
            ];
            const tempTotalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '临时仓总额计算公式：标签定格的成本价 * 商品总数'
            );
            const tempToStTotalCount = [
                h(
                    'div',
                    {
                        slot: 'content'
                    },
                    '将标签从临时仓上架存入到标准仓的商品总数'
                )
            ];
            const tempToStTotalAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '总额计算公式：标签定格的成本价 * 商品总数'
            );
            const goodsTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '上架总数 = 上架标准仓商品总数 + 临仓上架标准仓商品总数'
            );
            const labelTotalCount = h(
                'div',
                {
                    slot: 'content'
                },
                '扫标签上架所操作的标签总数（不包含PC手动入仓）'
            );
            const perfAmount = h(
                'div',
                {
                    slot: 'content'
                },
                '公式 = （上架标准仓 + 临仓上架标准仓商品总数）* 绩效'
            );
            return h('span', [
                h(
                    'el-tooltip',
                    {
                        props: {
                            placement: 'bottom'
                        }
                    },
                    [
                        column.property == 'StTotalCount' ? stTotalCount : '',
                        column.property == 'StTotalAmount' ? stTotalAmount : '',
                        column.property == 'TempTotalCount' ? tempTotalCount : '',
                        column.property == 'TempTotalAmount' ? tempTotalAmount : '',
                        column.property == 'TempToStTotalCount' ? tempToStTotalCount : '',
                        column.property == 'TempToStTotalAmount' ? tempToStTotalAmount : '',
                        column.property == 'GoodsTotalCount' ? goodsTotalCount : '',
                        column.property == 'LabelTotalCount' ? labelTotalCount : '',
                        column.property == 'PerfAmount' ? perfAmount : '',
                        h('i', {
                            class: 'el-icon-warning-outline',
                            style: 'color:orange;margin-right:5px;'
                        })
                    ]
                ),
                h('span', column.label)
            ]);
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return [sums];
        },
        // 重置表单
        resetSearch() {
            this.$refs.orgCascader.$refs.panel.clearCheckedNodes();
            this.searchData.SId = '';
            this.searchData.SIds = [];
            this.searchData.StartDate = '';
            this.searchData.EndDate = '';
            this.dateTime = [];
            this.searchData.PayStartDate = '';
            this.searchData.PayEndDate = '';
        },
        // 获取数据
        getPickerTableData() {
            this.$util
                .axiosPost({
                    url: '/api/DataStatistics/StockUpStat_V2',
                    data: this.searchData
                })
                .then(res => {
                    if (res.errcode != 201) {
                        let data = res.data;
                        this.tableData = data.DataList;
                        this.tableDataLength = res.count;

                        this.perfSetList = data.PerfSets;
                    }
                })
                .catch(() => {});
        },
        //获取组织树
        getSIdData() {
            if (this.searchData.OrgId) {
                this.$util.getSIdListByOrg(this.searchData.OrgId).then(data => {
                    this.SIdList = data;
                });
            }
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        handleChangeFinishTime(val) {
            if (val) {
                this.searchData.PayStartDate = val[0];
                this.searchData.PayEndDate = val[1];
            } else {
                this.searchData.PayStartDate = '';
                this.searchData.PayEndDate = '';
            }
        },
        getOrgTree(isShow) {
            if (isShow && this.orgSearchData.length == 0) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpInfoManagement/GetOrgTree'
                    })
                    .then(res => {
                        if (res.data) {
                            this.orgSearchData = this.getTreeData(res.data);
                        }
                    });
            }
        },
        // 数列
        getTreeData(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getTreeData(data[i].Childrens);
                }
            }
            return data;
        },
        // showStockUpHis(row) {
        //     if (row) {
        //         this.pickDialogTitle = '上架员【' + row.SName + '】上架数据';
        //         this.sId = row.SId;
        //         this.historyVisible = true;
        //     }
        // },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        sortChange(event) {
            this.SortProp = event.prop;
            this.SortType = event.order;
        },        
        exportData() {
            let that = this;
            if (that.tableData.length == 0) {
                that.$util.warningMsg('请选择要导出的数据');
                return;
            }
            that.$util.exportFile_post({
                url: '/api/DataStatistics/ExportStockUpStat',
                data:{StockUpStats:that.tableData,TableSetsModels:that.columnShowSets,SortProp:that.SortProp,SortType:that.SortType},
            });
        },        
    }
};
</script>
<style lang="less">
.table-ctn {
    .elx-table--body-wrapper {
        .elx-body--row {
            td {
                height: 36px;
            }
        }
    }
}
</style>
